export const INCREASE_REQUESTS_NO = "INCREASE_REQUESTS_NO";
export const DECREASE_REQUESTS_NO = "DECREASE_REQUESTS_NO";

export const SET_REQUESTS_TOKEN = "SET_REQUESTS_TOKEN";
